<mat-dialog-content class="mat-typography">
    <h2>Unable to complete</h2>
    <p>We encountered an error while pledging the loans below. Reselect the loans and try pledging again.</p>
    <ul class="loan-list">
        <li *ngFor="let loan of unsuccessfulLoans">
            <a href="/account/{{loan.id}}/profile" target="_blank" rel="noopener noreferrer">
                {{ loan.loanNumber }} - {{ loan.entityName }}
            </a>
        </li>
    </ul>
</mat-dialog-content>
<div mat-dialog-actions class="flex row end-center">
    <button mat-button cdkFocusInitial color="primary" [mat-dialog-close]="false">OK
    </button>
</div>